import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class OrderService {

  mangentoUrl = environment.apiURL
  constructor(private http: HttpClient) { }

  getOrders(data):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/orderDetail`, data);
  }

  getCopyOrders(data):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/reorder`, data);
  }

  getdiscontinueOrderItems(data):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/discontinueOrderItems`, data);
  }

  getnotMyRangeOrderItems(data):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/notMyRangeOrderItems`, data);
  }

  getoutOfStockOrderItems(data):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/outOfStockOrderItems`, data);
  }

  getavailableOrderItems(data):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/availableOrderItems`, data);
  }

  orderItemsAddToCart(data):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/orderItemsAddToCart`, data);
  }

  orderApplicationId(data):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/checkApplicationId`, data);
  }

  copyApplicationOrder(data):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/copyApplicationOrder`, data);
  }

}
